import { dispatcher } from '../Dispatcher'

export function setCurrentSection (section) {
  return dispatcher.dispatch({
    type: 'setCurrentSection',
    data: { section }
  })
}
